import { format, isAfter, isToday, isValid } from 'date-fns';
import MONTHS from '../constants/DateConstants';

const getFormattedDateForDatePicker = ({
  initialDate = '',
  today = new Date(),
  dateFormat = 'MM/dd/yyyy',
  defaultPastDateToToday = true,
} = {}) => {
  const previouslySelectedDateAvailable = initialDate ? new Date(`${initialDate}T10:00:00`) : today;
  const defaultDate = defaultPastDateToToday ? format(today, dateFormat) : '';
  return isAfter(previouslySelectedDateAvailable, today) ||
    (isToday(previouslySelectedDateAvailable) && isValid(new Date(initialDate)))
    ? format(new Date(previouslySelectedDateAvailable), dateFormat)
    : defaultDate;
};

function isValidDateStringFormatMMDDYYYY(dateString: string): boolean {
  // Regular expression pattern for mm/dd/yyyy format
  const pattern: RegExp = /^\d{2}\/\d{2}\/\d{4}$/;

  // Check if the string matches the pattern
  if (pattern.test(dateString)) {
    // Split the string into month, day, and year
    const [month, day, year] = dateString.split('/').map(Number);

    // Validate the month, day, and year values
    if (month >= 1 && month <= 12 && day >= 1 && day <= 31 && year >= 1000 && year <= 9999) {
      return true; // Valid date format
    }
  }

  return false; // Invalid date format
}

const getCurrentMonthString = (date: Date) => {
  return MONTHS[(date.getMonth() % 12) as keyof typeof MONTHS];
};

export { getCurrentMonthString, getFormattedDateForDatePicker, isValidDateStringFormatMMDDYYYY };
